import classNames from 'classnames';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { debounce } from 'lodash';

import { UserActions } from '../../../store/actions/users';
import { BotsCreators } from '../../../store/actions/bots';
import * as BotCreatorActions from '../../../store/actions/bot-creator';
import { ItemsCreators } from '../../../store/actions/items';
import { ConnectorsCreators } from '../../../store/actions/connectors';
import { deleteConnector, deleteItem } from '../../../util/builder/items';
import {
  ValidationType,
  ValidationTypeIcon,
  ValidationTypeName,
} from '../../../util/validation-type';

import './styles.scss';

import SelectTags from './SelectTags';
import SelectEscape from './SelectEscape';
import ConfirmDialog from '../../Header/ConfirmDialog';

import CollectingSettings from './CollectingSettings';
import CommonSettings from './CommonSettings';
import ConditionalSettings from './ConditionalSettings';
import EmailSettings from './EmailSettings';
import ErrorMessageSettings from './ErrorMessageSettings';
import JsonApiSettings from './JsonApiSettings';
import ApiV2 from './ApiV2';
import ImageMenu from './ImageMenu';
import ModuleSettings from './ModuleSettings';
import ScriptSettings from './ScriptSettings';
import SmsSettings from './SmsSettings';
import MenuSettings from './MenuSettings';
import MenuAISettings from './MenuAISettings';
import HumanSettings from './HumanSettings';
import IAConditionalSettings from './IAConditionalSettings';
import IALocalConditionalSettings from './IALocalConditionalSettings';
import QuickAccessToogle from './QuickAccessToogle';
import DynamicMediaSettings from './DynamicMediaSettings';
import CarouselSettings from './CarouselSettings';
import FormBlock from './FormBlock';
import VTexCheckoutSettings from './VTexCheckoutSettings';
import VTexAddToCartSettings from './VTexAddToCartSettings';
import VTexUpdateCartSettings from './VTexUpdateCartSettings';
import VTexRemoveFromCartSettings from './VTexRemoveFromCartSettings';
import VTexCatalogProductSettings from './VTexCatalogProductSettings';
import VTexCatalogProductsSettings from './VTexCatalogProductsSettings';
import VTexCartProductSettings from './VTexCartProductSettings';
import VTexOrderListSettings from './VTexOrderListSettings';
import ZendeskCreateRequestSettings from './ZendeskCreateRequestSettings';
import ZendeskListRequests from './ZendeskListRequestsSettings';
import ZendeskShowRequest from './ZendeskShowRequestSettings';
import ZendeskListComments from './ZendeskListCommentsSettings';
import ZendeskInsertComment from './ZendeskInsertCommentSettings';
import ZendeskAttachFile from './ZendeskAttachFileSettings';
import ZendeskUpdateStatusRequest from './ZendeskUpdateStatusRequestSettings';
import RedirectSettings from './RedirectSettings';
import GroupSettings from './GroupSettings';
import JiraCreateIssue from './Jira/JiraCreateIssue';
import JiraListIssues from './Jira/JiraListIssues';
import JiraShowIssue from './Jira/JiraShowIssue';
import JiraListProjects from './Jira/JiraListProjects';
import JiraListPriorities from './Jira/JiraListPriorities';
import JiraListStatus from './Jira/JiraListStatus';
import JiraListRequestypes from './Jira/JiraListRequestypes';
import JiraListComments from './Jira/JiraListComments';
import JiraInsertComment from './Jira/JiraInsertComment';
import JiraAttachFile from './Jira/JiraAttachFile';
import JiraUpdateStatusIssue from './Jira/JiraUpdateStatusIssue';
import MessageSuggestion from './MessageSuggestionSettings';
import BotTransferSettings from './BotTransferSettings';
import VoicebotSettings from './VoicebotSettings';
import RDStationInputSettings from './RDStationInputSettings';
import RDStationSubmitLeadSettings from './RDStationSubmitLeadSettings';
import GlpiCreateRequestSettings from './Glpi/GlpiCreateRequestSettings';
import GlpiListRequests from './Glpi/GlpiListRequestsSettings';
import GlpiShowRequest from './Glpi/GlpiShowRequestSettings';
import GlpiListComments from './Glpi/GlpiListCommentsSettings';
import GlpiInsertComment from './Glpi/GlpiInsertCommentSettings';
import GlpiAttachFile from './Glpi/GlpiAttachFileSettings';
import GlpiUpdateStatusRequest from './Glpi/GlpiUpdateStatusRequestSettings';
import GlpiListGroups from './Glpi/GlpiListGroupsSettings';

class MenuRight extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validationTypeName: ValidationTypeName[0],
      validationTypeIcon: ValidationTypeIcon[0],
      validationDowndownOpen: false,
      answerHandlerOpen: true,
      timeTypping: 1,
      validationType: ValidationType.Any,
      errorMessage: '',
      errorMessageFinal: '',
      validation: '',
      maxTries: '',
      variable: '',
      toggleIa: false,
      modalIsOpen: false,
      ...props.item,
      ...props.connectors,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { item } = this.props;
    if (nextProps?.item?._id !== item?._id) {
      const type = nextProps.item
        ? nextProps.item.validationType || ValidationType.Any
        : ValidationType.Any;
      this.setState({
        variable: '',
        validationType:
          nextProps.item && nextProps.item.type === 'Menu'
            ? ValidationType.Number
            : ValidationType.Any,
        validation:
          nextProps.item && nextProps.item.type === 'Menu' ? '^[0-9]+$' : '',
        errorMessage: '',
        errorMessageFinal: '',
        maxTries: '',
        validationDowndownOpen: false,
      });
      this.setState({
        ...nextProps.item,
        validationTypeName: ValidationTypeName[type],
        validationTypeIcon: ValidationTypeIcon[type],
      });
    }
  }

  doUpdateItem = (payload) => {
    const { editItem, item } = this.props;
    editItem({ ...item, ...payload });
  };

  handleCloseConfirmModal = () => {
    this.setState({ modalIsOpen: false });
  };

  handleConfirmDelete = () => {
    deleteItem(this.props, () => this.props);
    this.setState({ modalIsOpen: false });
  };

  doUpdateItemWithDebounce = debounce(this.doUpdateItem, 200);

  handleToggleIA = () => {
    const { item } = this.props;

    if (item.useIA == false || !item.useIA) {
      this.doUpdateItemWithDebounce({ useIA: true });
    }
    if (item.useIA == true) {
      this.doUpdateItemWithDebounce({ useIA: false });
    }
  };

  handleToggleIALocal = () => {
    const { item } = this.props;

    if (item.AILocal == false) {
      this.doUpdateItemWithDebounce({ AILocal: true });
    }
    if (item.AILocal == true) {
      this.doUpdateItemWithDebounce({ AILocal: false });
    }
  };

  editRightMenuName = (value) => {
    this.doUpdateItemWithDebounce({ title: value });
  };

  onTimeTyppingUpdate = (e) => {
    const { value } = e.target;
    this.setState({ timeTypping: value });
    this.doUpdateItemWithDebounce({ timeTypping: value });
  };

  onVariableUpdate = (value) => {
    this.setState({ variable: value });
    this.doUpdateItemWithDebounce({ variable: value });
  };

  onValidationUpdate = (e) => {
    const { value } = e.target;
    this.setState({ validation: value });
    this.doUpdateItemWithDebounce({ validation: value });
  };

  onErrorMessageUpdate = (e) => {
    const { value } = e.target;
    this.setState({ errorMessage: value });
    this.doUpdateItemWithDebounce({ errorMessage: value });
  };

  onErrorMessageFinalUpdate = (value) => {
    this.setState({ errorMessageFinal: value });
    this.doUpdateItemWithDebounce({ errorMessageFinal: value });
  };

  onMaxTriesUpdate = (e) => {
    const { value } = e.target;
    this.setState({ maxTries: value });
    this.doUpdateItemWithDebounce({ maxTries: value });
  };

  handleDeleteItem = () => {
    if (this.props.item.type.toLowerCase() === 'group') {
      this.setState({ modalIsOpen: true });
    } else {
      deleteItem(this.props, () => this.props);
    }
  };

  handleDeletePath = () => {
    deleteConnector(this.props, () => this.props);
  };

  handleCapture = (e) => {
    const { captureAnswer } = this.state;

    this.setState({ captureAnswer: !captureAnswer });
    this.doUpdateItemWithDebounce({ captureAnswer: !captureAnswer });
  };

  editUrlBlur = (e) => {
    if ((e.oldValue && e.oldValue === e.target.value) || !e.target.value) {
      return;
    }

    const { editItemUrlRequest, bot, item } = this.props;
    editItemUrlRequest(bot._id, item._id, e.target.value, item);
  };

  toggleValidationDropDown = () => {
    const { validationDowndownOpen } = this.state;
    this.setState({
      validationDowndownOpen: !validationDowndownOpen,
    });
  };

  toggleAnswerHandler = () => {
    const { answerHandlerOpen } = this.state;

    this.setState({
      answerHandlerOpen: !answerHandlerOpen,
    });
  };

  handleValidationChanged = (type) => {
    this.setState({
      validationType: type,
      validationTypeName: ValidationTypeName[type],
      validationTypeIcon: ValidationTypeIcon[type],
      validationDowndownOpen: false,
    });
    this.doUpdateItemWithDebounce({
      validationType: type,
    });
  };

  handleSettings = () => {
    const {
      validationType,
      validationTypeName,
      validationTypeIcon,
      validationDowndownOpen,
      answerHandlerOpen,
      validation,
      captureAnswer,
      variable,
    } = this.state;

    const { item, bot } = this.props;
    if (item && bot) {
      switch (item.type) {
        case 'Image':
          return (
            <ImageMenu
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'Collect':
          return (
            <CollectingSettings
              answerHandlerOpen={answerHandlerOpen}
              onVariableUpdate={this.onVariableUpdate}
              variable={variable}
              toggleAnswerHandler={this.toggleAnswerHandler}
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'Conditional':
          return (
            <ConditionalSettings
              user={this.props.user}
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'API':
          return (
            <JsonApiSettings
              answerHandlerOpen={answerHandlerOpen}
              toggleAnswerHandler={this.toggleAnswerHandler}
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );

        case 'APIV2':
          return (
            <ApiV2
              answerHandlerOpen={answerHandlerOpen}
              variable={variable}
              toggleAnswerHandler={this.toggleAnswerHandler}
              onVariableUpdate={this.onVariableUpdate}
              doUpdateItem={this.doUpdateItem}
              {...this.props}
            />
          );

        case 'VTexAddToCart':
          return (
            <VTexAddToCartSettings
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'VTexUpdateCart':
          return (
            <VTexUpdateCartSettings
              title="Atualizar carrinho VTex"
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'VTexRemoveFromCart':
          return (
            <VTexRemoveFromCartSettings
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'VTexCartProduct':
          return (
            <VTexCartProductSettings
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'VTexCatalogProduct':
          return <VTexCatalogProductSettings />;
        case 'VTexCatalogProducts':
          return (
            <VTexCatalogProductsSettings
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'VTexOrderList':
          return (
            <VTexOrderListSettings
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'VTexCheckout':
          return (
            <VTexCheckoutSettings
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'ZendeskCreateRequest':
          return (
            <ZendeskCreateRequestSettings
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'ZendeskListRequests':
          return (
            <ZendeskListRequests
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'ZendeskShowRequest':
          return (
            <ZendeskShowRequest
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'ZendeskListComments':
          return (
            <ZendeskListComments
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'ZendeskInsertComment':
          return (
            <ZendeskInsertComment
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'ZendeskAttachFile':
          return (
            <ZendeskAttachFile
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );

        case 'ZendeskUpdateStatusRequest':
          return (
            <ZendeskUpdateStatusRequest
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );

        case 'JiraCreateIssue':
          return (
            <JiraCreateIssue
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'JiraListIssues':
          return (
            <JiraListIssues
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'JiraShowIssue':
          return (
            <JiraShowIssue
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'JiraListProjects':
          return (
            <JiraListProjects
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'JiraListStatus':
          return (
            <JiraListStatus
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'JiraListRequestypes':
          return (
            <JiraListRequestypes
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'JiraListPriorities':
          return (
            <JiraListPriorities
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'JiraListComments':
          return (
            <JiraListComments
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'JiraInsertComment':
          return (
            <JiraInsertComment
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'JiraAttachFile':
          return (
            <JiraAttachFile
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );

        case 'JiraUpdateStatusIssue':
          return (
            <JiraUpdateStatusIssue
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );

        case 'GlpiCreateRequest':
          return (
            <GlpiCreateRequestSettings
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'GlpiListRequests':
          return (
            <GlpiListRequests
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'GlpiShowRequest':
          return (
            <GlpiShowRequest
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'GlpiListComments':
          return (
            <GlpiListComments
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'GlpiInsertComment':
          return (
            <GlpiInsertComment
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'GlpiAttachFile':
          return (
            <GlpiAttachFile
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'GlpiUpdateStatusRequest':
          return (
            <GlpiUpdateStatusRequest
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'GlpiListGroups':
          return (
            <GlpiListGroups
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'Carousel':
          return (
            <CarouselSettings
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'DynamicMedia':
          return (
            <DynamicMediaSettings
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'SMS':
          return (
            <SmsSettings
              answerHandlerOpen={answerHandlerOpen}
              toggleAnswerHandler={this.toggleAnswerHandler}
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'EMAIL':
          return (
            <EmailSettings
              answerHandlerOpen={answerHandlerOpen}
              toggleAnswerHandler={this.toggleAnswerHandler}
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'Script':
          return (
            <ScriptSettings
              answerHandlerOpen={answerHandlerOpen}
              toggleAnswerHandler={this.toggleAnswerHandler}
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'Module':
          return (
            <ModuleSettings
              answerHandlerOpen={answerHandlerOpen}
              toggleAnswerHandler={this.toggleAnswerHandler}
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'Form':
          return (
            <FormBlock
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'Human':
          return (
            <HumanSettings
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'Menu':
          return (
            <MenuSettings
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );
        case 'MenuAI':
          return (
            <>
              <MenuAISettings
                doUpdateItem={this.doUpdateItemWithDebounce}
                {...this.props}
              />
            </>
          );

        case 'VoiceTransferirRamalInternoExterno':
        case 'VoiceTTSAudio':
        case 'VoiceConfirmarVenda':
        case 'VoiceTTSAudioASR':
        case 'VoiceFinalizarAtendimento':
        case 'VoiceTransferirRamalLocalizadorVendedor':
        case 'VoiceAgendarMailing':
        case 'VoiceTTSAudioDTMF':
        case 'VoiceWebApiList':
        case 'VoiceSMS':
          return (
            <VoicebotSettings
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );

        case 'Group':
          return (
            <GroupSettings
              botId={bot?._id}
              zoomLevel={bot?.viewPosition?.zoomLevel || 1.0}
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );

        case 'Redirect':
          return (
            <RedirectSettings
              answerHandlerOpen={answerHandlerOpen}
              toggleAnswerHandler={this.toggleAnswerHandler}
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );

        case 'BotTransfer':
          return (
            <BotTransferSettings
              answerHandlerOpen={answerHandlerOpen}
              toggleAnswerHandler={this.toggleAnswerHandler}
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );

        case 'RdStationInput':
          return (
            <RDStationInputSettings
              variable={variable}
              validationTypeName={validationTypeName}
              validationTypeIcon={validationTypeIcon}
              validationDowndownOpen={validationDowndownOpen}
              toggleValidationDropDown={this.toggleValidationDropDown}
              validationType={validationType}
              validation={validation}
              captureAnswer={captureAnswer}
              handleCapture={this.handleCapture}
              onVariableUpdate={this.onVariableUpdate}
              handleValidationChanged={this.handleValidationChanged}
              onValidationUpdate={this.onValidationUpdate}
              answerHandlerOpen={answerHandlerOpen}
              toggleAnswerHandler={this.toggleAnswerHandler}
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );

        case 'RdStationSubmitLead':
          return (
            <RDStationSubmitLeadSettings
              variable={variable}
              validationTypeName={validationTypeName}
              validationTypeIcon={validationTypeIcon}
              validationDowndownOpen={validationDowndownOpen}
              toggleValidationDropDown={this.toggleValidationDropDown}
              validationType={validationType}
              validation={validation}
              captureAnswer={captureAnswer}
              handleCapture={this.handleCapture}
              onVariableUpdate={this.onVariableUpdate}
              handleValidationChanged={this.handleValidationChanged}
              onValidationUpdate={this.onValidationUpdate}
              answerHandlerOpen={answerHandlerOpen}
              toggleAnswerHandler={this.toggleAnswerHandler}
              doUpdateItem={this.doUpdateItemWithDebounce}
              {...this.props}
            />
          );

        default:
          return (
            <CommonSettings
              answerHandlerOpen={answerHandlerOpen}
              toggleAnswerHandler={this.toggleAnswerHandler}
              variable={variable}
              validationTypeName={validationTypeName}
              validationTypeIcon={validationTypeIcon}
              validationDowndownOpen={validationDowndownOpen}
              toggleValidationDropDown={this.toggleValidationDropDown}
              validationType={validationType}
              validation={validation}
              captureAnswer={captureAnswer}
              handleCapture={this.handleCapture}
              onVariableUpdate={this.onVariableUpdate}
              handleValidationChanged={this.handleValidationChanged}
              onValidationUpdate={this.onValidationUpdate}
              {...this.props}
            />
          );
      }
    }
    return (
      <CommonSettings
        answerHandlerOpen={answerHandlerOpen}
        toggleAnswerHandler={this.toggleAnswerHandler}
        variable={variable}
        validationTypeName={validationTypeName}
        validationTypeIcon={validationTypeIcon}
        validationDowndownOpen={validationDowndownOpen}
        toggleValidationDropDown={this.toggleValidationDropDown}
        validationType={validationType}
        validation={validation}
        captureAnswer={captureAnswer}
        handleCapture={this.handleCapture}
        onVariableUpdate={this.onVariableUpdate}
        handleValidationChanged={this.handleValidationChanged}
        onValidationUpdate={this.onValidationUpdate}
        {...this.props}
      />
    );
  };

  render() {
    const {
      answerHandlerOpen,
      timeTypping,
      errorMessage,
      maxTries,
      errorMessageFinal,
      captureAnswer,
      modalIsOpen,
    } = this.state;

    const { item, items, path, show } = this.props;

    const isMediaBlock =
      item && ['Video', 'Audio', 'Document'].includes(item.type);

    const hasErrorMessage = () => {
      if (!item) return false;

      const itemsWithCaptureAnswer = ['Text'];

      if (itemsWithCaptureAnswer.includes(item.type) && captureAnswer)
        return true;

      if (itemsWithCaptureAnswer.includes(item.type) && !captureAnswer)
        return false;

      const itemsWithWaitResponse = ['APIV2'];

      if (itemsWithWaitResponse.includes(item.type) && item.waitResponse)
        return true;

      if (itemsWithWaitResponse.includes(item.type) && !item.waitResponse)
        return false;

      const itemsWithErrorMessage = [
        'Text',
        'API',
        'APIV2',
        'Collect',
        'Menu',
        'MenuAI',
        'RdStationInput',
      ];
      return itemsWithErrorMessage.includes(item?.type);
    };

    const hasValidationMessage = () => {
      if (!item) return false;

      const itemsWithoutValidtionMessage = ['API', 'APIV2', 'MenuAI'];
      return !itemsWithoutValidtionMessage.includes(item.type);
    };

    const hasFinalMessage = () => {
      if (!item) return false;

      const itemsWithoutFinalMessage = [];
      return !itemsWithoutFinalMessage.includes(item.type);
    };

    const hasSelectEscape =
      (item &&
        [
          'VTexCatalogProducts',
          'VTexCatalogProduct',
          'VTexAddToCart',
          'VTexRemoveFromCart',
          'VTexCartProduct',
          'VTexUpdateCart',
          'ZendeskShowRequest',
          'ZendeskCreateRequest',
          'ZendeskListRequests',
          'ZendeskAttachFile',
          'ZendeskListComments',
          'ZendeskInsertComment',
          'ZendeskUpdateStatusRequest',
          'JiraShowIssue',
          'JiraCreateIssue',
          'JiraListIssues',
          'JiraListProjects',
          'JiraListStatus',
          'JiraListRequestypes',
          'JiraListPriorities',
          'JiraAttachFile',
          'JiraListComments',
          'JiraInsertComment',
          'JiraUpdateStatusIssue',
          'Conditional',
        ].includes(item.type)) ||
      item?.type?.startsWith('Glpi');

    const hasntQuickAccess =
      item &&
      [
        'VTexCatalogProducts',
        'VTexCatalogProduct',
        'VTexAddToCart',
        'VTexRemoveFromCart',
        'VTexCartProduct',
        'VTexUpdateCart',
        'VTexCheckout',
        'ZendeskShowRequest',
        'ZendeskCreateRequest',
        'ZendeskListRequests',
        'ZendeskAttachFile',
        'ZendeskListComments',
        'ZendeskInsertComment',
        'ZendeskUpdateStatusRequest',
        'JiraShowIssue',
        'JiraCreateIssue',
        'JiraListIssues',
        'JiraListProjects',
        'JiraListStatus',
        'JiraListRequestypes',
        'JiraListPriorities',
        'JiraAttachFile',
        'JiraListComments',
        'JiraInsertComment',
        'JiraUpdateStatusIssue',
        'GlpiShowRequest',
        'GlpiCreateRequest',
        'GlpiListRequests',
        'GlpiAttachFile',
        'GlpiListComments',
        'GlpiInsertComment',
        'GlpiUpdateStatusRequest',
        'GlpiListGroups',
        'VTexOrderList',
        'RdStationInput',
        'RdStationSubmitLead',
      ].includes(item.type);

    const hasTimeTypping =
      item &&
      [
        'Text',
        'Menu',
        'Image',
        'Video',
        'Audio',
        'Document',
        'Collect',
        'Conditional',
        'API',
        'APIV2',
        'SMS',
        'EMAIL',
        'Script',
        'Module',
        'Human',
        'DynamicMedia',
        'Carousel',
        'VTexAddToCart',
        'VTexUpdateCart',
        'VTexRemoveFromCart',
        'VTexOrderList',
        'VTexCatalogProduct',
        'VTexCatalogProducts',
        'VTexCheckout',
        'MenuAI',
        'Form',
      ].includes(item.type);

    const hasSwitchIa =
      item &&
      ['Text', 'Menu', 'APIV2', 'Form', 'Carousel', 'RdStationInput'].includes(
        item.type
      );

    const hasSwitchIaLocal = item && ['MenuAI'].includes(item.type);

    const blockId = item && item._id ? item._id : '';

    let blocoOrigem = '';

    let blocoDestino = '';

    if (path) {
      [blocoOrigem] = items.filter((item_) => item_._id === path.from);
      [blocoDestino] = items.filter((item_) => item_._id === path.to);
    }

    const titleBlocoOrigem = () => {
      if (blocoOrigem?.type?.startsWith('Voice')) {
        return (
          blocoOrigem?.voiceSettings?.deIvrStep?.trim() +
            (path?.voiceSettings?.nmIvrResult
              ? ` | ${path?.voiceSettings?.nmIvrResult}`
              : '') || ''
        );
      }

      return blocoOrigem?.title;
    };

    const titleBlocoDestino = () => {
      if (blocoDestino?.type?.startsWith('Voice')) {
        return blocoDestino?.voiceSettings?.deIvrStep?.trim();
      }

      return blocoDestino?.title;
    };

    return (
      <>
        <Fragment>
          <div className={`menu-bot-criador ${show ? '' : 'hidden'}`}>
            <div className="menu-criador-botoes">
              <button className="bt-bot-on" type="button">
                <img alt="" src="/assets/images/icons/icon_bot_config_on.svg" />
              </button>
            </div>
            <div className="menu-criador-box">
              <div className="menu-criador-box-conteudo" id="style-criador">
                {/* CONECTOR SELECIONADO */}
                <div
                  className={classNames({
                    'd-none': !path,
                    'selected-path-box': true,
                  })}
                >
                  <div className="form-group mb-2">
                    <label>Bloco de origem</label>
                    <div>
                      <input
                        className="input-control"
                        type="text"
                        value={titleBlocoOrigem() || ''}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="form-group mb-2">
                    <label>Bloco de destino</label>
                    <div>
                      <input
                        className="input-control"
                        type="text"
                        value={titleBlocoDestino() || ''}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="criador-box-bt">
                    <button onClick={this.handleDeletePath} type="button">
                      <img alt="" src="/assets/images/icons/icon_delete.svg" />
                      Apagar ligação
                    </button>
                  </div>
                </div>

                {/* BLOCO SELECIONADO */}
                <div className={classNames({ 'd-none': !item })}>
                  <div className="right-menu-input-container">
                    <input
                      value={(item && item.title) || ''}
                      placeholder="Nome"
                      type="text"
                      disabled
                    />
                  </div>
                  <div className="criador-box-id">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlInput1">ID</label>
                      <input
                        type="text"
                        className="form-control outline-none"
                        disabled
                        id="exampleFormControlInput1"
                        value={blockId}
                      />
                      <div className="criador-box-id-icone pointer">
                        <CopyToClipboard text={blockId}>
                          <img
                            alt=""
                            src="/assets/images/icons/icon_copiar.svg"
                          />
                        </CopyToClipboard>
                      </div>
                    </div>
                    <div className="switch-ia-container">
                      {/* HABILITAR DESABILITAR IA LOCAL */}
                      {hasSwitchIaLocal ? (
                        <IALocalConditionalSettings
                          item={item}
                          toggleIa={this.handleToggleIALocal}
                          {...this.props}
                        />
                      ) : null}
                    </div>
                    <div className="switch-ia-container">
                      {/* HABILITAR DESABILITAR IA */}
                      {hasSwitchIa ? (
                        <IAConditionalSettings
                          item={item}
                          toggleIa={this.handleToggleIA}
                          {...this.props}
                        />
                      ) : null}
                    </div>
                    {!hasntQuickAccess &&
                      item?.type &&
                      !item?.type?.startsWith('Voice') && (
                        <div className="switch-quick-access-container">
                          <QuickAccessToogle
                            doUpdateItem={this.doUpdateItemWithDebounce}
                            {...this.props}
                          />
                        </div>
                      )}
                  </div>

                  {item?.type && !item?.type?.startsWith('Voice') && (
                    <SelectTags
                      onSelect={(values) => this.doUpdateItem({ tags: values })}
                      {...this.props}
                    />
                  )}

                  {/* TEMPO DIGITANDO */}
                  {hasTimeTypping ? (
                    <div className="criador-box-tempo">
                      <label htmlFor="exampleFormControlInput1">
                        Tempo Digitando:
                      </label>
                      <input
                        type="number"
                        value={timeTypping}
                        onChange={this.onTimeTyppingUpdate}
                        className="form-control outline-none input-time-typping"
                        id="exampleFormControlInput1"
                      />
                      <p>segundos</p>
                    </div>
                  ) : null}
                  {/* CONFIGURAÇÕES DOS BLOCOS */}
                  <div
                    className={
                      item && item.type !== 'Form'
                        ? 'criador-box-texto'
                        : 'criador-box-texto question-box'
                    }
                    hidden={isMediaBlock}
                  >
                    {/* CONFIGURAÇÕES DE ACORDO COM O TIPO DE BLOCO */}
                    {this.handleSettings()}

                    {hasSelectEscape && (
                      <SelectEscape
                        onSelect={(value) =>
                          this.doUpdateItem({ conditionEscape: value })
                        }
                        label="Escape"
                        destinationId={item?.conditionEscape}
                      />
                    )}

                    {/* BLOCOS QUE POSSUEM MENSAGEM DE ERRO */}
                    {hasErrorMessage() && (
                      <ErrorMessageSettings
                        captureAnswer={captureAnswer}
                        answerHandlerOpen={answerHandlerOpen}
                        errorMessage={errorMessage}
                        onErrorMessageUpdate={this.onErrorMessageUpdate}
                        maxTries={maxTries}
                        onMaxTriesUpdate={this.onMaxTriesUpdate}
                        errorMessageFinal={errorMessageFinal}
                        onErrorMessageFinalUpdate={
                          this.onErrorMessageFinalUpdate
                        }
                        item={item}
                        items={items}
                        onSelect={(value) => this.doUpdateItem(value)}
                        hasValidationMessage={hasValidationMessage()}
                        hasFinalMessage={hasFinalMessage()}
                      />
                    )}

                    {/* BLOCOS QUE POSSUEM SUGESTÃO DE MENSAGEM */}
                    {item && item.type === 'Text' ? (
                      <>
                        {captureAnswer && (
                          <MessageSuggestion
                            doUpdateItem={this.doUpdateItem}
                            {...this.props}
                          />
                        )}
                      </>
                    ) : (
                      ''
                    )}
                  </div>

                  <div className="criador-box-bt">
                    <button onClick={this.handleDeleteItem} type="button">
                      <img
                        className="criador-box-bt-img"
                        alt=""
                        src="/assets/images/icons/icon_delete.svg"
                      />
                      Apagar bloco
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
        <ConfirmDialog
          title="Confirmar exclusão"
          body="Você tem certeza que deseja excluir o bloco de grupo? Todo fluxo que está dentro do bloco será perdido."
          show={modalIsOpen}
          handleClose={this.handleCloseConfirmModal}
          onConfirm={this.handleConfirmDelete}
        >
          Deseja realmente deletar o bloco?
        </ConfirmDialog>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
  item: state.items.currentItem,
  items: state.items.allItems,
  itemsToRemove: state.items.itemsToRemove,
  connectors: state.connectors.list,
  connectorsToRemove: state.items.connectorsToRemove,
  path: state.items.currentPath,
  user: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...ItemsCreators,
      ...BotsCreators,
      ...ConnectorsCreators,
      ...UserActions,
      ...BotCreatorActions,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MenuRight)
);
